import {
  validatePostalCodeWrapper,
  isValueWholeNumberWrapper,
  validateYearFormatWrapper,
  validateDateFormatWrapper,
  isDateInThePastWrapper,
  validatePhoneNumberWrapper,
  validateEmailAddressWrapper,
  validateRiskUnitsNumberWrapper,
  validateDateWithinRangeWrapper,
  validateDateNotAfterWrapper,
  validateDateWithinRangeOfDateWrapper,
  requiredByValuesWrapper,
  requiredByValuesExceptWhenWrapper,
  requiredByRuleWrapper,
  enabledByValuesWrapper,
  requiredWhenNotEmptyWrapper,
  requiredByOperationWrapper,
  validateNameWrapper
} from "./backend-validation.validator";

export const validatorFuncs = {
  "isValueWholeNumber": isValueWholeNumberWrapper,
  "validateYearFormat": validateYearFormatWrapper,
  "validatePostalCode": validatePostalCodeWrapper,
  "validateDateFormat": validateDateFormatWrapper,
  "isDateInThePast": isDateInThePastWrapper,
  "validatePhoneNumber": validatePhoneNumberWrapper,
  "validateEmailAddress": validateEmailAddressWrapper,
  "validateRiskUnitsNumber": validateRiskUnitsNumberWrapper,
  "validateDateWithinRange": validateDateWithinRangeWrapper,
  "validateDateNotAfter": validateDateNotAfterWrapper,
  "validateDateWithinRangeOfDate": validateDateWithinRangeOfDateWrapper,
  "requiredByValues": requiredByValuesWrapper,
  "requiredByValuesExceptWhen": requiredByValuesExceptWhenWrapper,
  "requiredByRule": requiredByRuleWrapper,
  "enabledByValues": enabledByValuesWrapper,
  "requiredWhenNotEmpty": requiredWhenNotEmptyWrapper,
  "requiredByOperation": requiredByOperationWrapper,
  "validateName": validateNameWrapper
}